import { render, staticRenderFns } from "./TempConfigDeptModal.vue?vue&type=template&id=0b09775c&scoped=true"
import script from "./TempConfigDeptModal.vue?vue&type=script&lang=js"
export * from "./TempConfigDeptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b09775c",
  null
  
)

export default component.exports